// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-2498bc02] .vs__dropdown-toggle {

    width: 100%;

    border-radius: 12px !important;

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem
}
.form[data-v-2498bc02] .vs__dropdown-toggle,
      .input-select--light[data-v-2498bc02] .vs__dropdown-toggle {

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.formulate-input[data-is-showing-errors='true'][data-v-2498bc02] .vs__dropdown-toggle {

    border-radius: 12px;

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(216 0 3 / var(--tw-border-opacity))
}
.patch_form[data-v-2498bc02] .vs__dropdown-toggle {

    --tw-bg-opacity: 1;

    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.fotocasa[data-v-2498bc02] .vs__dropdown-toggle {

    border-radius: 6px;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem
}
[data-v-2498bc02] .vs__dropdown-toggle .vs__search {

    width: 0;

    border-radius: 0px;

    border-width: 0px;

    border-style: none;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0;

    padding-bottom: 0;

    --tw-text-opacity: 1;

    color: rgb(107 114 128 / var(--tw-text-opacity));

    outline: 2px solid transparent !important;

    outline-offset: 2px !important;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
[data-v-2498bc02] .vs__dropdown-toggle svg {

    fill: #009AFA
}
.fotocasa[data-v-2498bc02] .vs__dropdown-toggle svg {

    fill: #6B7280
}
[data-v-2498bc02] .vs__dropdown-menu {

    border-radius: 12px;

    border-width: 1px;

    border-style: solid;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity));

    padding: 0
}
[data-v-2498bc02] .vs__dropdown-option {

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(31 41 55 / var(--tw-text-opacity))
}
[data-v-2498bc02] .vs__dropdown-option--highlight {

    --tw-bg-opacity: 1;

    background-color: rgb(237 247 253 / var(--tw-bg-opacity));

    --tw-text-opacity: 1;

    color: rgb(31 41 55 / var(--tw-text-opacity))
}
.fotocasa[data-v-2498bc02] .vs__dropdown-option {

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    padding-left: 1rem;

    padding-right: 1rem
}
[data-v-2498bc02] .vs__no-options {

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(31 41 55 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
[data-v-2498bc02] .vs__search {

    z-index: 0;

    margin: 0
}
[data-v-2498bc02] .vs__search:focus {

    margin: 0
}
[data-v-2498bc02] .vs__actions {

    padding-top: 0;

    padding-bottom: 0
}
[data-v-2498bc02] .vs__selected {

    margin-top: 0;

    width: 100%;

    --tw-text-opacity: 1;

    color: rgb(31 41 55 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
[data-v-2498bc02] .vs__selected-options {

    flex-wrap: nowrap
}
[data-v-2498bc02] .vs__label {

    margin: 0;

    --tw-text-opacity: 1;

    color: rgb(31 41 55 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.fotocasa[data-v-2498bc02] .vs__label {

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
[data-v-2498bc02] .vs__subtitle {

    margin-top: 0.25rem;

    --tw-text-opacity: 1;

    color: rgb(107 114 128 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
[data-v-2498bc02] .slot__wrapper {

    justify-content: space-between;

    gap: 0.5rem
}
`, "",{"version":3,"sources":["webpack://./resources/js/funnels/components/form/triotecaSelect/TriotecaSelect.vue"],"names":[],"mappings":";AAgFA;;IAAA,WAAA;;IAAA,8BAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,QAAA;;IAAA,kBAAA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,cAAA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,yCAAA;;IAAA,8BAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA;AAAA;AAGA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAKA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA,UAAA;;IAAA;AAAA;AAAA;;IAAA;AAAA;AAGA;;IAAA,cAAA;;IAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA,SAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAKA;;IAAA,8BAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <VueSelectInput\n    v-model=\"context.model\"\n    :options=\"options\"\n    v-bind=\"context.attributes\"\n    :reduce=\"x => x.value\"\n    autocomplete=\"disabled\"\n    :multiple=\"multiple\"\n    @option:selecting=\"selecting\"\n    @option:selected=\"selected\"\n  >\n    <template #option=\"{ label, subtitle, prefix, suffix, component }\">\n      <template v-if=\"!component\">\n        <PrefixSuffixSlot :prefix=\"prefix\" :suffix=\"suffix\">\n          <p class=\"vs__label\">{{ label }}</p>\n        </PrefixSuffixSlot>\n\n        <p v-if=\"!!subtitle\" class=\"vs__subtitle\">{{ subtitle }}</p>\n      </template>\n\n      <template v-else>\n        <component :is=\"component.name\" v-bind=\"component.props\" v-on=\"component.events\">\n          <template v-for=\"(slot, name) in component.slots\" #[name]>\n            <div v-bind:key=\"name\" v-html=\"slot\"></div>\n          </template>\n        </component>\n      </template>\n    </template>\n\n    <template #selected-option=\"{ label, prefix, suffix }\">\n      <PrefixSuffixSlot :prefix=\"prefix\" :suffix=\"suffix\">\n        <p class=\"vs__label\">{{ label }}</p>\n      </PrefixSuffixSlot>\n    </template>\n\n    <div slot=\"no-options\">No hay opciones disponibles.</div>\n  </VueSelectInput>\n</template>\n\n<script>\nimport PrefixSuffixSlot from '@/lego/components/appends/PrefixSuffixSlot.vue';\n\nexport default {\n  components: {\n    VueSelectInput: () => import('vue-select'),\n    PrefixSuffixSlot,\n  },\n  props: {\n    context: {\n      type: Object,\n      required: true,\n    },\n  },\n  computed: {\n    options() {\n      return this.context.options;\n    },\n    multiple() {\n      return this.context.attributes.multiple ?? false;\n    },\n  },\n  methods: {\n    selecting(e) {\n      this.$emit('option:selecting', e);\n    },\n    selected(e) {\n      this.$emit('option:selected', e);\n    },\n  },\n};\n</script>\n\n<style lang=\"postcss\">\n@import 'vue-select/dist/vue-select.css';\n</style>\n\n<style lang=\"postcss\" scoped>\n/deep/ .vs {\n  &__dropdown {\n    &-toggle {\n      @apply w-full !rounded-md border-hairline bg-neutral-white border-neutral-semilight px-nano py-micro;\n\n      .form &,\n      .input-select--light& {\n        @apply bg-neutral-white border-neutral-semilight;\n      }\n      .formulate-input[data-is-showing-errors='true']& {\n        @apply rounded-md border-feedback-error-medium border-hairline;\n      }\n      .patch_form & {\n        @apply bg-neutral-lightest;\n      }\n      .fotocasa & {\n        @apply rounded-s py-nano;\n      }\n\n      .vs__search {\n        @apply style-body-sm text-neutral-semidark !outline-none px-nano py-0 border-none w-0 rounded-none;\n      }\n      svg {\n        @apply fill-support-dark;\n\n        .fotocasa & {\n          @apply fill-neutral-semidark;\n        }\n      }\n    }\n    &-menu {\n      @apply p-0 border-solid rounded-md border-hairline border-neutral-semilight;\n    }\n    &-option {\n      @apply px-xxs py-micro text-neutral-darkest;\n\n      &--highlight {\n        @apply bg-support-lightest text-neutral-darkest;\n      }\n\n      .fotocasa & {\n        @apply py-nano px-xxxs;\n      }\n    }\n  }\n  &__no-options {\n    @apply px-xxs py-micro style-body-sm text-neutral-darkest;\n  }\n  &__search {\n    @apply z-0 m-0 focus:m-0;\n  }\n  &__actions {\n    @apply py-0;\n  }\n  &__selected {\n    @apply mt-0 style-body-sm text-neutral-darkest w-full;\n\n    &-options {\n      @apply flex-nowrap;\n    }\n  }\n  &__label {\n    @apply style-body-sm text-neutral-darkest m-0;\n\n    .fotocasa & {\n      @apply style-overline;\n    }\n  }\n  &__subtitle {\n    @apply style-overline mt-quark text-neutral-semidark;\n  }\n}\n/deep/ .slot {\n  &__wrapper {\n    @apply justify-between gap-nano;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
